"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const qrcode_react_1 = __importDefault(require("qrcode.react"));
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  background-color: #777777;
  height: 92vh;
  z-index: 11;
  perspective: 1px;
  width: 100vw;
  color: #fff;
  padding: 16px;
  @media (min-width: 840px) {
    padding: 24px;
  }
  @media (orientation: landscape) {
    flex-direction: row;
  }
`;
const TextArea = styled_components_1.default.div `
  flex-basis: 30%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  gap: 2vmin;

  @media (orientation: landscape) {
    flex-basis: 50%;
  }
`;
const SecondaryText = styled_components_1.default.div `
  font-size: 3.5vmin;
  font-weight: 200;
  text-align: center;
  flex-basis: 50%;
  @media (orientation: landscape) {
    flex-basis: auto;
  }
`;
const MainText = styled_components_1.default.div `
  font-size: 7vmin;
  text-align: center;
  flex-basis: 50%;
  @media (orientation: landscape) {
    flex-basis: auto;
  }
`;
const QrWrapper = styled_components_1.default.div `
  margin: 0 auto;
  @media (orientation: landscape) {
    flex-basis: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  canvas {
    width: 40vw !important;
    height: 40vw !important;
    @media (orientation: landscape) {
      width: 25vw !important;
      height: 25vw !important;
    }
    border: 2vmin solid #fff;
  }
`;
const CallToActionArea = (props) => (react_1.default.createElement(Wrapper, { className: "call-to-action-detail" },
    react_1.default.createElement(TextArea, null,
        props.secondaryText && (react_1.default.createElement(SecondaryText, { className: "secondary-text" }, props.secondaryText)),
        props.mainText && (react_1.default.createElement(MainText, { className: "main-text" }, props.mainText))),
    react_1.default.createElement(QrWrapper, null,
        react_1.default.createElement(qrcode_react_1.default, { value: props.qrValue }))));
exports.default = CallToActionArea;
